import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://cdn4.vectorstock.com/i/1000x1000/75/83/404-error-page-not-found-plug-graphic-vector-19997583.jpg" className='w-screen' alt="" />
        </div>
    );
};

export default NotFound;